import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero-section">
        <div className="hero-content">
          <h1>Welcome to Texas Craft Wings</h1>
          <p>Experience the perfect blend of flavor and tradition</p>
          <div className="hero-buttons">
            <Link to="/menu" className="primary-button">View Menu</Link>
            <Link to="/locations" className="secondary-button">Find Location</Link>
          </div>
        </div>
      </section>

      <section className="features-banner">
        <div className="container">
          <h1 className="welcome-heading">WELCOME TO TEXAS CRAFT WINGS!</h1>
          <p className="subtitle">We are a brand new casual eating restaurant now open in Willis, TX, with a second location coming soon to Katy, TX serving up delicious wings, craft beer, burgers, and super crave-able twists on classic American cuisine.</p>
          
          <div className="features-layout">
            <div className="features-left">
              <div className="feature-card">
                <h3 className="feature-heading">CRAFT ON DRAFT</h3>
                <p className="feature-text">For beer lovers, we offer a wide selection of local craft beers that pair perfectly with our menu. Whether you're in the mood for an IPA or a stout, we've got you covered.</p>
              </div>
              
              <div className="feature-card">
                <h3 className="feature-heading">TAKE ME AWAY!</h3>
                <p className="feature-text">If you're in the mood for a night in or you have to get back to the office, we offer take-out options so you can take our delicious food with you.</p>
              </div>
            </div>
            
            <div className="features-center">
              <img src="/images/chiken_wings_bbq_sauce_3-copy-e1682088042401.png" alt="Delicious Wing" className="wing-image" />
            </div>
            
            <div className="features-right">
              <div className="feature-card">
                <h3 className="feature-heading">JUST WING IT</h3>
                <p className="feature-text">Whether you're in the mood for spicy or sweet, we have any flavor of wing you're craving. Check out our sauce options for bone-in wings and boneless wings.</p>
              </div>
              
              <div className="feature-card">
                <h3 className="feature-heading">WANT MORE?</h3>
                <p className="feature-text">Our unique menu also includes appetizers, burgers, and other twists on classic American dishes.</p>
              </div>
            </div>
          </div>
          
          <div className="about-button-container">
            <Link to="/about" className="about-button">ABOUT TEXAS CRAFT WINGS</Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Featured Menu Items</h2>
            <p>Discover our most popular dishes made with the finest ingredients</p>
          </div>
          <div className="menu-preview">
            <div className="menu-item">
              <div className="menu-item-image">
                <img src="/images/double-fried-wings-e1694794972623-custom_crop.png" alt="Traditional Wings" />
              </div>
              <div className="menu-item-info">
                <h3>Traditional Wings</h3>
                <p>Classic wings tossed in your choice of signature sauces</p>
                <div className="price">$13.99</div>
                <Link to="/menu" className="view-menu-button">View Options</Link>
              </div>
            </div>
            <div className="menu-item">
              <div className="menu-item-image">
                <img src="/images/sweet-thai-chili-boneless-wings-custom_crop.png" alt="Boneless Wings" />
              </div>
              <div className="menu-item-info">
                <h3>Boneless Wings</h3>
                <p>100% white meat chicken with crispy breading</p>
                <div className="price">$12.99</div>
                <Link to="/menu" className="view-menu-button">View Options</Link>
              </div>
            </div>
            <div className="menu-item">
              <div className="menu-item-image">
                <img src="/images/chicken-tenders-copy-e1694794894123-custom_crop.png" alt="Chicken Tenders" />
              </div>
              <div className="menu-item-info">
                <h3>Chicken Tenders</h3>
                <p>Hand-breaded tenders served with your favorite sauce</p>
                <div className="price">$11.99</div>
                <Link to="/menu" className="view-menu-button">View Options</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About Texas Craft Wings</h2>
              <p>We take pride in serving the best wings in Texas. Our commitment to quality means using only the finest ingredients and preparing everything fresh to order. Experience the perfect blend of traditional recipes and modern craft flavors.</p>
              <Link to="/about" className="primary-button">Learn More</Link>
            </div>
            <div className="about-image">
              <img src="/images/battered-wings-e1694751568381-custom_crop.png" alt="Fresh cooked wings" />
            </div>
          </div>
        </div>
      </section>

      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2>Become A Craft Wing VIP</h2>
            <p>Join our newsletter to receive exclusive offers, updates, and promotions</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Your email address" required />
              <button type="submit" className="primary-button">Subscribe</button>
            </form>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Order?</h2>
          <p>Get your favorite wings delivered right to your door</p>
          <button className="primary-button">Order Now</button>
        </div>
      </section>
    </div>
  );
};

export default Home;
